import { configureStore } from '@reduxjs/toolkit';
import tilesReducer from './slices/tilesSlice';
import kitchensReducer from './slices/kitchensSlice';
import bathroomsReducer from './slices/bathroomsSlice';
import bedroomsReducer from './slices/bedroomsSlice';
import livingRoomsReducer from './slices/livingRoomsSlice';
import commercialReducer from './slices/commercialSlice';
import elevationsReducer from './slices/elevationsSlice';
import tabletopsReducer from './slices/tabletopsSlice';
import stepRisersReducer from './slices/stepRisersSlice';
import authReducer from './slices/authSlice';
import { toastError, toastSuccess } from '../utils/toast';

const toastMiddleware = () => (next) => (action) => {
  const type = action?.type || '';

  // Errors: toast for any rejected thunk
  if (type.endsWith('/rejected')) {
    toastError(action?.payload || action?.error, 'Action failed');
  }

  // Success: only for write operations (avoid noisy fetch toasts)
  if (type.endsWith('/fulfilled')) {
    const isWrite =
      type.includes('/create') ||
      type.includes('/update') ||
      type.includes('/delete') ||
      type.includes('/remove') ||
      type.includes('/upload');

    if (isWrite) {
      toastSuccess('Saved successfully');
    }
  }

  return next(action);
};

export const store = configureStore({
  reducer: {
    auth: authReducer,
    tiles: tilesReducer,
    kitchens: kitchensReducer,
    bathrooms: bathroomsReducer,
    bedrooms: bedroomsReducer,
    livingRooms: livingRoomsReducer,
    commercial: commercialReducer,
    elevations: elevationsReducer,
    tabletops: tabletopsReducer,
    stepRisers: stepRisersReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(toastMiddleware),
});

// Type exports for TypeScript (if needed)
// export type RootState = ReturnType<typeof store.getState>;
// export type AppDispatch = typeof store.dispatch;
